import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-deadlines.svg'

const CustomDeadlinesBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Custom Deadlines Available</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      When you create a deadline on the Alerts & Deadline page within your Agency Admin page,
      specific custom deadlines will be displayed.
      If you don&apos;t see deadlines here you&apos;re expecting, please speak to support.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default CustomDeadlinesBlankState
